import styled from "styled-components";

import PageBackground from "../assets/images/PageBackground.svg";

export const Main = styled.main`
  max-width: 1100px;
  width: 100%;
  flex: 1;
  padding: 4rem 1rem 4rem;
  margin: 0 auto;
  background: url(${PageBackground}) center center / auto no-repeat;
`;
